import { useState } from 'react';
import { bulkOpsUserData } from '../Http/Index';
import { ShowAlert } from '../GlobalComponent/Alerts/Alert';

export type BulkAction = 'CREATE' | 'UPDATE' | 'DELETE' | 'IDENTIFY_ADD' | 'IDENTIFY_DELETE';

export const useBulkOpsJob = (action: BulkAction, fileName: string, onSuccess?: () => void) => {
  const [isLoading, setIsLoading] = useState(false);

  const submit = async (file: File | null, companyId: string | null) => {
    if (!file) return ShowAlert('warning', 'Please upload a file.');
    if (!companyId) return ShowAlert('warning', 'Please select a company.');
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('companyId', companyId);
      formData.append('action', action);
      await bulkOpsUserData(formData);
      ShowAlert('success', `Job submitted! Check status in the tracker below.`);
      onSuccess?.();
    } catch (e: any) {
      ShowAlert('warning', e?.response?.data?.message || 'Error submitting job');
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, submit };
};
